import { createSlice } from "@reduxjs/toolkit";
import { MARKET_WATCH_COLUMNS } from "../../Static/data";

const marketSlice = createSlice({
  name: "market",
  initialState: {
    marketActiveTab: "all",
    marketWatchScripts: [],
    marketFilterScript: [],
    marketExchangeScript: [],
    marketWatchColumns: MARKET_WATCH_COLUMNS,
  },
  reducers: {
    setMarketWatchScripts(state, action) {
      state.marketWatchScripts = action.payload;
    },
    setMarketWatchColumns(state, action) {
      state.marketWatchColumns = action.payload;
    },
    setMarketWatchClearScript(state, action) {
      state.marketWatchScripts = [];
    },
    setMarketFilterScript(state, action) {
      state.marketFilterScript = action.payload;
    },
    setMarketActiveTab(state, action) {
      state.marketActiveTab = action.payload;
    },
    setExchangeScript(state, action) {
      state.marketExchangeScript = action.payload;
    },
  },
});

export const marketAction = marketSlice.actions;
export default marketSlice;
